// src/i18n/index.js
import { createI18n } from "vue-i18n";



// start with no messages — they'll be loaded dynamically
const i18n = createI18n({
  legacy: false,
  locale: "en", // default language
  fallbackLocale: "en",
  messages: {}, // empty — load.js will fill this
  missingWarn: false,
  fallbackWarn: false,
  onError(err, ctx) {
    console.error("[i18n error]", {
      message: err?.message,
      code: err?.code,
      key: ctx?.key,
      locale: ctx?.locale,
      values: ctx?.values,
    });
    throw err;
  },
});

export default i18n;
export { i18n };
